// ============================================================================
// MarketDisputeOpenForm — открытие спора участником (заказчик/мастер).
// Причина обязательна (выбор), комментарий обязателен (описание ситуации).
// ============================================================================

import { useState } from 'react';
import { Loader2, ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DISPUTE_REASONS, type DisputeReason } from '@/lib/marketDispute';

export function MarketDisputeOpenForm({
  requestId,
  busy,
  onOpen,
}: {
  requestId: string;
  busy: boolean;
  onOpen: (reason: DisputeReason, comment: string) => void;
}) {
  const [reason, setReason] = useState<DisputeReason>('quality');
  const [comment, setComment] = useState('');
  const canSubmit = !!comment.trim() && !busy;

  return (
    <>
      <div className="text-sm font-semibold">Открыть спор</div>
      <div className="mt-1 text-[11px] leading-5 text-muted-foreground">
        Спор увидят операторы маркетплейса. Обсуждение идёт в чате заявки, история сохраняется.
      </div>
      <label className="mt-3 block text-[11px] font-medium text-muted-foreground" htmlFor={`dispute-reason-${requestId}`}>
        Причина
      </label>
      <select
        id={`dispute-reason-${requestId}`}
        value={reason}
        onChange={(e) => setReason(e.target.value as DisputeReason)}
        className="mt-1 h-10 w-full rounded-xl border bg-background px-3 text-sm outline-none focus:ring-2 focus:ring-primary/40"
        disabled={busy}
      >
        {DISPUTE_REASONS.map((r) => (
          <option key={r.value} value={r.value}>{r.label}</option>
        ))}
      </select>
      <label className="mt-3 block text-[11px] font-medium text-muted-foreground" htmlFor={`dispute-comment-${requestId}`}>
        Что случилось <span className="text-destructive">*</span>
      </label>
      <textarea
        id={`dispute-comment-${requestId}`}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        rows={4}
        placeholder="Опишите ситуацию: что произошло, что уже обсуждали с другой стороной"
        className="mt-1 w-full resize-y rounded-xl border bg-background px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary/40"
        disabled={busy}
      />
      <Button
        type="button"
        className="mt-3 h-10 w-full rounded-xl"
        onClick={() => onOpen(reason, comment)}
        disabled={!canSubmit}
      >
        {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <ShieldAlert className="mr-1.5 h-4 w-4" />}
        Открыть спор
      </Button>
    </>
  );
}
